import localScaleManager from "../../../../helpers/LocalScaleManager";
import FastBetButton from "./fastBetButton";
import RaiseWheel from "./raiseWheel";
import { RaiseInput } from "./raiseInput";
import { ActionButton } from "../actionButton";
import { WebSocketManager } from "../../../../helpers/webSocketManager";
import { tweenConfigs } from "../../../../helpers/tweensConfigs";

export default class RaiseButton extends ActionButton {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param gameObj {Phaser.GameObjects.Image}
   */
  constructor(scene, table, gameObj) {
    super(scene, table, "raise-btn", "poker.client-push.raise", false, gameObj);
    this.tableNumber = table.tableNumber;
    this.scene = scene;
    this.table = table;
    this.menuIsActive = false;
    this.allowMenuToggle = true;
    this.menuOffset = 0;
    this.minRaise = 0;
    this.maxRaise = 0;
    this.maxBet = 0;
    this.pot = 0;
    this.playerBet = 0;
    this.confirmBtnPointerDown = false;
    this.menu = this.scene.add.group();
    this.table.poolArray.push(this.menu);

    this.userBalance = 0;
    this.menuBg = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "raise-bg")
      .setOrigin(0);
    this.table.poolArray.push(this.menuBg);

    // this.confirmBtn = new Button(scene, "raise-confirm-btn", true);
    this.confirmBtn = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "raise-confirm-btn")
      .setInteractive({ cursor: "pointer" });
    this.table.poolArray.push(this.confirmBtn);

    this.confirmBtn.on("pointerdown", this.onConfirmBtnPointerDown, this);
    this.confirmBtn.on("pointerup", this.onConfirmBtnPointerUp, this); //D
    // this.confirmBtn.on('pointerdown', this.onConfirmClicked, this);

    this.fastBetButtons = this.scene.add.group();
    this.table.poolArray.push(this.fastBetButtons);

    this.mainBtnsText = ["HalfPot", "TwoThirdPot", "Pot"];
    this.currentBtnsText = ["1/2Pot", "2/3Pot", "Pot"];
    for (let i = 0; i < this.mainBtnsText.length; i++) {
      this.fastBetButtons.add(
        new FastBetButton(scene, i, this.mainBtnsText[i], this, this.table)
      );
    }

    this.menuWheel = new RaiseWheel(scene, this, this.table);

    this.inputValue = 0;
    this.menuInput = new RaiseInput(scene, this, this.table);

    this.menu.addMultiple([
      this.menuBg,
      this.menuInput,
      this.menuInput.inputText,
      this.menuWheel,
      this.menuWheel.chip,
      this.confirmBtn,
      ...this.fastBetButtons.getChildren(),
      ...this.fastBetButtons.getChildren().map((btn) => btn.text),
    ]);
    Phaser.Actions.SetDepth(this.menu.getChildren(), 91);
    Phaser.Actions.SetVisible(this.menu.getChildren(), false);

    this.overlay = this.table.overlay;
    // this.overlay = this.scene.add.rectangle(0, 0, 0, 0, 0x000000);
    // this.overlay.setAlpha(0);
    // this.overlay.setDepth(90);
    // this.table.poolArray.push(this.overlay);

    this.sortedTxtBtns = [
      "Disabled",
      "Min",
      "HalfPot",
      "TwoThirdPot",
      "ThreeFourthPot",
      "Pot",
      "2X",
      "3X",
      "Max",
    ];
  }
  updateFastBetButtons(gameState) {
    this.minRaise = gameState.minimumRaise;
    // if(gameState.maximumRaise === -1){
    //     this.maxRaise = gameState.playerInfo? gameState.playerInfo.balance + gameState.playerInfo.bet: gameState.minimumRaise;
    // } else this.maxRaise = gameState.maximumRaise;
    this.maxRaise = gameState.playerInfo
      ? gameState.playerInfo.maximumRaise
      : 0;
    this.pot = gameState.pot;
    this.playerBet = gameState.playerInfo ? gameState.playerInfo.bet : 0;
    this.maxBet = gameState.maxBet ? gameState.maxBet : 0;
    this.userBalance = gameState.playerInfo ? gameState.playerInfo.balance : 0;
    this.updateFastBetButtonsTxt(
      gameState.state === "PreFlop" ? "preFlop" : "postFlop"
    );
  }
  setFastBetButtonsTxt(betButtons) {
    this.mainBtnsText = betButtons;
    this.updateFastBetButtonsTxt("postFlop");
  }

  /**
   * @param state {"postFlop" | "preFlop"}
   */
  updateFastBetButtonsTxt(state) {
    let betButtons =
      state === "postFlop" ? this.mainBtnsText : ["2X", "3X", "Max"];
    if (JSON.stringify(this.currentBtnsText) === JSON.stringify(betButtons))
      return;
    let TextBtn,
      min,
      array = [],
      temp;
    for (let i = 0; i < betButtons.length; i++) {
      array.push({
        text: betButtons[i],
        index: this.sortedTxtBtns.findIndex((t) => t === betButtons[i]),
      });
    }
    for (let i = 0; i < array.length; i++) {
      min = array[i];
      for (let j = i + 1; j < array.length; j++) {
        if (array[j].index < min.index) {
          temp = min;
          min = array[j];
          array[j] = temp;
        }
      }
      betButtons[i] = min.text;
    }
    this.currentBtnsText = betButtons;
    betButtons.forEach((betButton, index) => {
      switch (betButton) {
        case "Max": {
          TextBtn = "Max";
          break;
        }
        case "TwoThirdPot": {
          TextBtn = "2/3Pot";
          break;
        }
        case "HalfPot": {
          TextBtn = "1/2Pot";
          break;
        }
        case "Min": {
          TextBtn = "Min";
          break;
        }
        case "Pot": {
          TextBtn = "Pot";
          break;
        }
        case "ThreeFourthPot": {
          TextBtn = "3/4Pot";
          break;
        }
        case "2X": {
          TextBtn = "2X";
          break;
        }
        case "3X": {
          TextBtn = "3X";
          break;
        }
        case "Disabled": {
          TextBtn = "Disabled";
          break;
        }
      }
      this.fastBetButtons.getChildren()[index].updateTxt(TextBtn);
    });
  }

  async onClick() {
    if (
      // this.allowMenuToggle &&
      this.scene.isSceneObjectsInteractive &&
      this.btnClicked
    ) {
      this.disableInteractive();
      this.btnClicked = false;
      try {
        await this.onClickTween();
      } catch (e) {
        console.log(e);
      }
      // this.allowMenuToggle = false;
      // if(!this.menuIsActive){ /* on show */
      // this.setFrame("raise-confirm-btn");
      this.showOverlay();
      this.table.buttonManager.hideAllButtons();
      this.menuIsActive = true;
      this.inputValue = this.minRaise;
      // this.menu.children.iterate((child) => {
      //   child.y = child.getData("initY");
      // });
      // if (this.scene.tweenEnable) {
      // this.scene.tweens.add({
      //   targets: this.menu.getChildren(),
      //   duration: 300,
      //   ease: "Back",
      //   y: `-=${this.menuOffset}`,
      //   alpha: {
      //     delay: 80,
      //     value: 1,
      //     duration: 150,
      //     ease: "Power2",
      //   },
      // onComplete: () => {
      // this.menu.children.iterate((child) => {
      //   child.y = child.getData("initY") - this.menuOffset;
      // });
      // Phaser.Actions.SetAlpha(this.menu.getChildren(), 1);
      // this.confirmBtn.setInteractive({ cursor: "pointer" });
      // this.allowMenuToggle = true;
      // this.menuInput.setValue(this.inputValue);
      // this.menuWheel.fillByAmount(this.inputValue);
      // },
      // });
      // } else {
      // this.menu.children.iterate((child) => {
      //   child.y = child.getData("initY") - this.menuOffset;
      // });
      // Phaser.Actions.SetAlpha(this.menu.getChildren(), 0);
      Phaser.Actions.SetVisible(this.menu.getChildren(), true);
      this.confirmBtn.setInteractive({ cursor: "pointer" });
      // this.allowMenuToggle = true;
      this.menuInput.setValue(this.inputValue);
      this.menuWheel.fillByAmount(this.inputValue);
      // }
      // } else { /* on hide */

      // }
    }
  }

  onConfirmBtnPointerDown() {
    this.confirmBtnPointerDown = true;
  }
  onConfirmBtnPointerUp() {
    if (this.confirmBtnPointerDown) {
      this.confirmBtnPointerDown = false;
      this.confirmBtn.disableInteractive();
      const data = {
        tableId: this.table.tableInfo.id,
        bet: this.inputValue,
      };
      let timeout = setTimeout(() => {
        this.confirmBtn.setInteractive({ cursor: "pointer" });
      }, 3000);
      WebSocketManager.emitEvent(data, this.serverEventAddress)
        .then(() => {
          this.hide();
          this.loading = false;
        })
        .finally(() => {
          this.confirmBtn.setInteractive({ cursor: "pointer" });
          clearTimeout(timeout);
          timeout = null;
        });
    }
  }
  hide() {
    this.shown = false;
    // let self = this;
    // if (this.scene.tweenEnable) {
    //   this.scene.tweens.add({
    //     targets: this,
    //     duration: tweenConfigs.actionButtons.hide.duration,
    //     ease: tweenConfigs.actionButtons.hide.ease,
    //     y: this.scene.gameHeight + this.displayHeight,
    //     onComplete: () => {
    //       self.y = self.scene.gameHeight + self.displayHeight;
    //       //FIXME: (sentry) Cannot read properties of undefined (reading 'sys')
    //       self.setInteractive({ cursor: "pointer" });
    //       // self.setVisible(false);
    //     },
    //   });
    // } else {
    // self.y = self.scene.gameHeight + self.displayHeight;
    // this.enableInteractive();
    // if (this.gameObj.visible) this.gameObj.setVisible(false);
    // }
    this.hideRaiseMenu();
  }

  hideRaiseMenu() {
    if (this.menuIsActive) {
      // if (this.menuIsActive && this.allowMenuToggle) {
      // this.allowMenuToggle = false;
      this.menuIsActive = false;
      this.hideOverlay();
      // if (this.scene.tweenEnable) {
      // this.scene.tweens.add({
      //   targets: this.menu.getChildren(),
      //   duration: 350,
      //   ease: "Linear",
      //   alpha: {
      //     value: 0,
      //     duration: 70,
      //     ease: "Power2",
      //   },
      //   y: `+=${this.menuOffset}`,
      //   onComplete: () => {
      //     this.menu.children.iterate((child) => {
      //       child.y = child.getData("initY") + this.menuOffset;
      //     });
      //     Phaser.Actions.SetAlpha(this.menu.getChildren(), 0);
      //     this.allowMenuToggle = true;
      //   },
      // });
      // } else {
      // this.menu.children.iterate((child) => {
      //   child.y = child.getData("initY") + this.menuOffset;
      // });
      // Phaser.Actions.SetAlpha(this.menu.getChildren(), 0);
      Phaser.Actions.SetVisible(this.menu.getChildren(), false);
      // this.allowMenuToggle = true;
      // }
    }
  }
  showOverlay() {
    if (!this.overlay.visible) {
      this.table.offOverlayEvents();
      this.overlay.on("pointerdown", this.overlayOnClick, this);
      this.overlay.setVisible(true);
    }
    // this.overlay.setAlpha(0.01);
    // this.scene.tweens.add({
    //   targets: this.overlay,
    //   duration: 300,
    //   ease: "Linear",
    //   alpha: 0.01,
    //   onComplete: () => {},
    // });
  }
  show(type) {
    this.shown = true;
    if (this.gameObj.frame.name !== `${type}-btn`)
      this.gameObj.setFrame(`${type}-btn`, false, false);
    this.enableInteractive();
    if (!this.gameObj.visible) this.gameObj.setVisible(true);
    // super.show();
  }
  overlayOnClick() {
    // return new Promise((resolve) => {
    // if (this.allowMenuToggle) {
    // this.allowMenuToggle = false;
    this.menuIsShowing = false;
    this.hideOverlay();
    this.menuIsActive = false;
    // if (this.scene.tweenEnable) {
    //   this.scene.tweens.add({
    //     targets: this.menu.getChildren(),
    //     duration: 350,
    //     ease: "Linear",
    //     alpha: {
    //       value: 0,
    //       duration: 70,
    //       ease: "Power2",
    //     },
    //     y: `+=${this.menuOffset}`,
    //     onComplete: () => {
    //       this.allowMenuToggle = true;
    //       this.menu.children.iterate((child) => {
    //         child.y = child.getData("initY") + this.menuOffset;
    //       });
    //       Phaser.Actions.SetAlpha(this.menu.getChildren(), 0);
    //       this.allowMenuToggle = true;
    //       this.table.buttonManager.handleGameState(this.table.gameState);
    //       resolve();
    //     },
    //   });
    // } else {
    // this.allowMenuToggle = true;
    // this.menu.children.iterate((child) => {
    //   child.y = child.getData("initY") + this.menuOffset;
    // });
    // Phaser.Actions.SetAlpha(this.menu.getChildren(), 0);
    Phaser.Actions.SetVisible(this.menu.getChildren(), false);
    // this.allowMenuToggle = true;
    this.table.buttonManager.handleGameState(this.table.gameState);
    // resolve();
    // }
    // }
    // });
  }
  hideOverlay() {
    this.scene.changeObjectsInteractivity(true);
    if (this.overlay.visible) {
      this.table.offOverlayEvents();
      this.overlay.setVisible(false);
    }
    // this.scene.tweens.add({
    //   targets: this.overlay,
    //   duration: 30,
    //   ease: "Linear",
    //   alpha: 0,
    // });
  }
  /**
   * @param width -> table.displayWidth
   * @param height -> table.height
   */
  positionControls(width, height) {
    this.tableNumber = this.table.tableNumber;
    const initX = this.scene.gameWidth * (this.tableNumber - 1);
    // super.positionControls(width, height, "right");
    let btnSize = width / 3.1;
    // let btnScale = localScaleManager.scaleSprite(
    //   this,
    //   btnSize,
    //   btnSize,
    //   0,
    //   1,
    //   true
    // );
    let btnScale = localScaleManager.scaleSprite(
      this.confirmBtn,
      btnSize,
      btnSize,
      0,
      1,
      true
    );
    this.confirmBtn.setPosition(this.gameObj.x, this.gameObj.y);

    localScaleManager.scaleSpriteTo(this.menuBg, btnScale * 2);
    this.menuBg.setPosition(
      initX + this.scene.gameWidth / 2 + (this.gameObj.displayWidth * 3) / 4.5,
      this.scene.gameHeight -
        (this.menuBg.displayHeight + this.gameObj.displayHeight * 1.6)
    );
    this.menuOffset = this.menuBg.displayHeight * 2;

    this.fastBetButtons.getChildren().forEach((btn, i) => {
      btn.positionControls(
        width - this.confirmBtn.displayWidth,
        width / 1.1,
        initX + this.scene.gameWidth / 2 - width / 2,
        this.gameObj.y
      );
    });
    this.menuWheel.positionControls(btnScale * 2, this.menuBg.x, this.menuBg.y);
    this.menuInput.positionControls(
      this.menuBg.displayWidth,
      this.menuBg.displayHeight,
      this.menuBg.x,
      this.menuBg.y
    );

    // if (!this.menuIsActive) {
    //   Phaser.Actions.IncY(this.menu.getChildren(), this.menuOffset);
    //   Phaser.Actions.SetAlpha(this.menu.getChildren(), 0);
    // }
    // this.menu.children.iterate((child) => {
    //   child.setData("initY", child.y);
    // });
    // this.show(false, false)
    // this.overlay.width = this.scene.gameWidth;
    // this.overlay.height = this.scene.gameHeight;
    // this.overlay.setPosition(initX, 0);
    // this.overlay.setInteractive(
    //   new Phaser.Geom.Rectangle(
    //     0,
    //     0,
    //     this.overlay.displayWidth,
    //     this.overlay.displayHeight
    //   ),
    //   Phaser.Geom.Rectangle.Contains
    // );
    // this.overlay.on("pointerdown", this.overlayOnClick, this);
  }
  /**
   * @param width -> table.displayWidth
   * @param height -> table.height
   */
  reposition(width, height) {
    this.tableNumber = this.table.tableNumber;
    const initX = this.scene.gameWidth * (this.tableNumber - 1);
    // super.reposition(width, height, "right");

    this.confirmBtn.setPosition(this.gameObj.x, this.gameObj.y);

    this.menuBg.setPosition(
      initX + this.scene.gameWidth / 2 + (this.gameObj.displayWidth * 3) / 4.5,
      this.scene.gameHeight -
        (this.menuBg.displayHeight + this.gameObj.displayHeight * 1.6)
    );
    this.menuOffset = this.menuBg.displayHeight * 2;

    this.fastBetButtons.getChildren().forEach((btn, i) => {
      btn.reposition(
        width - this.confirmBtn.displayWidth,
        width / 1.1,
        initX + this.scene.gameWidth / 2 - width / 2,
        this.gameObj.y
      );
    });
    this.menuWheel.reposition(this.menuBg.x, this.menuBg.y);
    this.menuInput.reposition(
      this.menuBg.displayWidth,
      this.menuBg.displayHeight,
      this.menuBg.x,
      this.menuBg.y
    );

    // if (!this.menuIsActive) {
    //   Phaser.Actions.IncY(this.menu.getChildren(), this.menuOffset);
    //   Phaser.Actions.SetAlpha(this.menu.getChildren(), 0);
    // }
    // this.menu.children.iterate((child) => {
    //   child.setData("initY", child.y);
    // });
  }
  remove() {
    super.remove();
    this.menuBg.destroy();
    this.fastBetButtons.getChildren().forEach((btn) => btn.remove());
    this.menuWheel.remove();
    this.menuInput.remove();
  }
}
